<template>
	<div>
		<div style="padding-bottom: 30px;">
			<div class="w">
				<!-- header -->
				<SecondHead activeIndex="9" textColor="#333" color="#333"></SecondHead>
			</div>
			<div style="background-color: #f2f2f2;padding-top: 2px;">
				<div class="management">
					<div class="sidebar" >
						<div class="sidebartitle" @click="setIndex(1)">
							<div class="pitchOnTrue" v-if="menuIndex == 1"><img src="../../assets/chouyang1.png" alt="" class="btn-img" /></div>
							<div class="pitchOnfalse" v-else><img src="../../assets/chouyang.png" alt="" class="btn-img" /></div>
							<span :class="menuIndex == 1 ? 'btnTitleClick' : 'btnTitle'">随机抽样</span>
						</div>
						<div class="sidebartitle" @click="setIndex(2)">
							<div class="pitchOnTrue" v-if="menuIndex == 2"><img src="../../assets/yonghuguanli1.png" alt="" class="btn-img" /></div>
							<div class="pitchOnfalse" v-else><img src="../../assets/yonghuguanli.png" alt="" class="btn-img" /></div>
							<span :class="menuIndex == 2 ? 'btnTitleClick' : 'btnTitle'">访员管理</span>
						</div>
						<div class="sidebartitle" @click="setIndex(3)">
							<div class="pitchOnTrue" v-if="menuIndex == 3"><img src="../../assets/bangding1.png" alt="" class="btn-img" /></div>
							<div class="pitchOnfalse" v-else><img src="../../assets/bangding.png" alt="" class="btn-img" /></div>
							<span :class="menuIndex == 3 ? 'btnTitleClick' : 'btnTitle'">坐席绑定</span>
						</div>
						<div class="sidebartitle" @click="setIndex(4)">
							<div class="pitchOnTrue" v-if="menuIndex == 4"><img src="../../assets/leixing1.png" alt="" class="btn-img" /></div>
							<div class="pitchOnfalse" v-else><img src="../../assets/leixing.png" alt="" class="btn-img" /></div>
							<span :class="menuIndex == 4 ? 'btnTitleClick' : 'btnTitle'">挂机设置</span>
						</div>
					</div>
					<router-view class="box" v-if="$route.path == '/addQuestionBankWJ'"></router-view>
					<div v-else class="managementList">
						<RandomSampling v-if="menuIndex == 1"></RandomSampling>
						<VisitorManagement v-if="menuIndex == 2"></VisitorManagement>
						<SeatBinding v-if="menuIndex == 3"></SeatBinding>
						<SetOverallStatus v-if="menuIndex == 4"></SetOverallStatus>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SecondHead from '@/components/SecondHead';
import RandomSampling from './randomSampling.vue';
import SeatBinding from './seatBinding.vue';
import VisitorManagement from './visitorManagement.vue';
import SetOverallStatus from './setOverallStatus.vue';
export default {
	name: 'managementIndex',
	components: {
		SecondHead,
		SeatBinding,
		RandomSampling,
		VisitorManagement,
		SetOverallStatus
	},
	computed:{
		lang()  {
			return localStorage.getItem('lang')
		}
	},
	data() {
		return {
			permissionList: {},
			menuIndex: 1,
			height: 0,
			rightheight: 0
		};
	},
	created() {
		if (this.$route.query.back) {
			this.menuIndex = this.$route.query.back;
		} else {
			this.menuIndex = 1;
		}
		this.accessPermission();
	},
	mounted() {
		var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
		this.height = winHeight - 108;
		this.rightheight = winHeight - 60;
		window.onresize = () => {
			var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
			this.height = winHeight - 108;
			this.rightheight = winHeight - 60;
		};
	},
	methods: {
		setIndex(index) {
			this.menuIndex = index;
		},
		accessPermission() {
			let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
			// console.log(userInfo.permissionList);
			let arr = userInfo.permissionList;
			let permissionList = {};
			arr.forEach((item, index) => {
				permissionList['admin' + item] = item;
			});
			console.log(permissionList);
			this.permissionList = permissionList;

			if (permissionList.admin1026) {
				this.menuIndex = 1;
			} else if (permissionList.admin1027) {
				this.menuIndex = 2;
			} else if (permissionList.admin1028) {
				this.menuIndex = 3;
			} else if (permissionList.admin1029) {
				this.menuIndex = 4;
			} else if (permissionList.admin1030) {
				this.menuIndex = 5;
			} else if (permissionList.admin1031) {
				this.menuIndex = 6;
			} else if (permissionList.admin1032) {
				this.menuIndex = 7;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.box {
	background-color: #fff;
	width: 100%;
	min-width: 1030px;
}
.management {
	// width: 1200px;
	// margin: 0px auto;
	min-height: calc(100vh - 150px);
	padding-top: 2px;
	display: flex;
	min-height: 500px;
	// justify-content: space-between;
	// border: 1px solid #cccccc;
	background-color: #ffffff;
	.sidebar {
		min-width: 80px;
		max-width: 80px;
		text-align: center;
		// padding: 20px 10px 20px 10px;
		border-right: 1px solid #ccc;
		box-sizing: border-box;
		.sidebartitle {
			// border: 1px solid #cccccc;
			// margin-bottom: 10px;
			color: #000000;
			padding: 10px 0;
			cursor: pointer;
			text-align: center;

			.pitchOnTrue {
				margin: 0px auto;
				width: 50px;
				height: 50px;
				border-radius: 5px;
				background-color: #0080ff;
			}
			.pitchOnfalse {
				margin: 0px auto;
				width: 50px;
				height: 50px;
				border-radius: 5px;
			}
			.btn-img {
				margin-top: 10px;
			}
			.btnTitle {
				display: block;
				// margin-top: 20px;
				font-size: 14px;
			}
			.btnTitleClick {
				display: block;
				// margin-top: 20px;
				color: #0080ff;
				font-size: 14px;
			}
		}
	}
	.managementList {
		width: 100%;
		// width: calc(100% - 80px);
		// min-width: 1000px;
		// max-width: 1000px;
		// border: 1px solid #cccccc;
		// background-color: #ffffff;
	}
}
</style>
